import '../../../../../theme/reorder.css';
import { IonBadge, IonButton, IonButtons, IonContent, IonFab, IonFabButton, IonFooter, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonLoading, IonModal, IonPage, IonPopover, IonReorder, IonReorderGroup, IonTitle, IonToast, IonToggle, IonToolbar, isPlatform, ItemReorderEventDetail, useIonAlert, useIonViewDidEnter } from '@ionic/react';
import imageCompression from 'browser-image-compression';
import { add, addOutline, arrowBack, cameraOutline, closeOutline, cogOutline, ellipseOutline, ellipsisVertical, fastFoodOutline, layersOutline, pencilOutline, pizzaOutline, reorderTwo, storefrontOutline, trashOutline } from 'ionicons/icons';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { alterarProdutosCategoriaEmpresa, assinaUrl, ordernarItemCategoriaProdutosEmpresa, removerProdutosCategoriaNovoEmpresa, requestService } from '../../../../../Utils/Services';
import imgDefaultImage from './imgs/defaultImage.svg';
import "./ProdutosCategoriasNovo.css";


type Props = {
  embedded?: boolean;
  categoriaSelecionada?: string;
  onSelecionarCategoria?: (nome: string) => void;
  solicitarNovaCategoria?: number;
};

const escaparHtml = (texto: any) => String(texto ?? '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#039;');

const ProdutosCategoriasNovo: React.FC<Props> = (props: Props) => {

  const history = useHistory<any>();
  const [showLoading, setShowLoading] = useState(false);
  const [listaCategoriaProdutos, setListaCategoriaProdutos] = useState<any>([]);

  const [showDetalhes, setShowDetalhes] = useState(false);
  const [menuCategoria, setMenuCategoria] = useState<{ categoria: any; indice: number; event: Event } | null>(null);
  const contentRef = useRef<HTMLIonContentElement | null>(null);
  const [index, setIndex] = useState("");
  const [nome, setNome] = useState("");

  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");


  const { loja, setLoja } = useContext(MessageContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  const [sizes, setSizes] = useState([{ name: '', sabores: 0 }]);

  const [massas, setMassas] = useState([{ name: '', price: 0 }]);
  const [bordas, setBordas] = useState([{ name: '', price: 0 }]);

  const [tipo, setTipo] = useState('');
  const [etapa, setEtapa] = useState(1);

  const podeEditar = acessos?.configuracoes === 'edicao';
  const { embedded = false, categoriaSelecionada = '', onSelecionarCategoria } = props;

  const inputRef = useRef<any>(null);
  const inputUploadArquivoRef = useRef<any>(null);

  const [checkedCobrarPorMaiorValor, setCheckedCobrarPorMaiorValor] = useState(false);

  const [fileDataURL, setFileDataURL] = useState<any>(null);
  const [fileArquivos, setFileArquivos] = useState<any>();
  const imageMimeType = /image\/(png|jpg|jpeg|avif|webp)/i;

  const [mostartAlerta] = useIonAlert();

  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);

  const isWeb = isPlatform('desktop');

  function removerAcentos(texto: string) {
    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function aplicarPrefixoNomeItemPizza(item: any, prefixo: 'Massa' | 'Borda') {
    const name = String(item?.name || '').trim();

    if (!name) {
      return { ...item, name };
    }

    const nameNormalizado = removerAcentos(name).toLowerCase();
    const prefixoNormalizado = removerAcentos(prefixo).toLowerCase();

    return {
      ...item,
      name: nameNormalizado.startsWith(prefixoNormalizado) ? name : `${prefixo} ${name}`,
    };
  }

  function normalizarComplementosPizzaParaSalvar() {
    if (tipo !== 'pizzas') {
      return { massas, bordas };
    }

    return {
      massas: massas?.map((massa) => aplicarPrefixoNomeItemPizza(massa, 'Massa')) || [],
      bordas: bordas?.map((borda) => aplicarPrefixoNomeItemPizza(borda, 'Borda')) || [],
    };
  }

  useEffect(() => {

    // console.log("*****************", fileArquivos);
    let fileReader: FileReader, isCancel = false;
    if (fileArquivos) {
      fileReader = new FileReader();
      fileReader.onload = (e) => {
        const result = e.target;
        if (result && !isCancel) {
          setFileDataURL(result.result);
          // atualizarTamanhoImagem();
        }
      }
      fileReader.readAsDataURL(fileArquivos);
    }
    return () => {
      isCancel = true;
      if (fileReader && fileReader.readyState === 1) {
        fileReader.abort();
      }
    }
  }, [fileArquivos]);

  useIonViewDidEnter(() => {
    if (!embedded) {
      setEsconderMenu(true);
      setNomeMenu("");
    }

    setListaCategoriaProdutos(dadosEmpresa.categoriaProdutos || []);

    //carregarConta();
    // if (inputRef.current) {
    //   inputRef.current.setFocus();
    // }
  });


  useEffect(() => {
    setListaCategoriaProdutos(dadosEmpresa.categoriaProdutos || []);
  }, [dadosEmpresa.categoriaProdutos]);

  const abrirNovaCategoria = useCallback(() => {
    setIndex('');
    setNome('');
    setTipo('');
    setFileArquivos(null);
    setFileDataURL(null);
    setEtapa(1);
    setSizes([]);
    setMassas([]);
    setBordas([]);
    setCheckedCobrarPorMaiorValor(false);
    setShowDetalhes(true);
  }, []);

  useEffect(() => {
    if (props.solicitarNovaCategoria && podeEditar) abrirNovaCategoria();
  }, [props.solicitarNovaCategoria, podeEditar, abrirNovaCategoria]);

  function deletarCategoria(indice: any) {

    // Verifica se a categoria está sendo usada no catálogo
    const categoriaParaRemover = listaCategoriaProdutos[indice];
    const catalogoProdutos = dadosEmpresa.catalogoProdutos || [];

    const categoriaEmUso = catalogoProdutos.some((produto: any) =>
      produto.categoria === categoriaParaRemover.nome
    );

    if (categoriaEmUso) {
      setTextToast("Não é possível excluir esta categoria pois existem produtos associados a ela.");
      setShowToast(true);
      return;
    }

    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }

    const delCategoria = async () => {
      const resp = await fetch(removerProdutosCategoriaNovoEmpresa.url.replace("{id}", loja.replace(/#/g, "%23")),
        {
          method: removerProdutosCategoriaNovoEmpresa.method,
          headers: [
            ["token", token]
          ],
          body: JSON.stringify({ 'index': indice }),
          credentials: 'include'
        });
      const response = await resp.json();

      if (response) {
        setListaCategoriaProdutos(response.message.Attributes.categoriaProdutos || []);
        setDadosEmpresa({ ...dadosEmpresa, categoriaProdutos: response.message.Attributes.categoriaProdutos || [] });


        console.log("retorno", response);
        setTextToast("Categoria removida com sucesso.");
        setShowToast(true);
      }
      // carregarConta();
    }

    delCategoria();

  }


  async function assinaUploadS3ArquivoESalvar(file: any) {
    const atualizar = async () => {
      let fileParts = file && file.name ? file.name.split('.') : [];
      let fileNameArquivo = fileParts[0] || '';
      let fileTypeArquivo = fileParts[1] || '';

      let params = {
        nome: fileNameArquivo,
        tipo: fileTypeArquivo
      }

      try {
        setShowLoading(true);

        let urlImagem = '', nomeImagem = '', tipoImagem = '';

        // console.log("file", file);
        if (file && file.name) {
          // Assina URL
          const resp = await fetch(assinaUrl.url.concat("?pasta=produtos-categoria&bucket=xeguei-mobile-publico"), {
            method: assinaUrl.method,
            headers: [
              ["token", localStorage.getItem("token") || ""]
            ],
            body: JSON.stringify(params),
            credentials: 'include'
          });

          const response = await resp.json();

          if (response.Item) {




            // const compressedFile = await imageCompression(file, {
            //   maxSizeMB: 0.1,
            //   maxWidthOrHeight: 600,
            //   useWebWorker: true,
            //   initialQuality: 0.5
            // });

            // console.log("Tamanho comprimido:", compressedFile.size);

            // console.log("fileTypeArquivo", fileTypeArquivo);

            const uploadToS3 = await fetch(response.Item.urlAssinado, {
              method: "PUT",
              headers: {
                "Content-Type": "image/" + fileTypeArquivo,
              },
              body: file,
            });

            if (uploadToS3.status === 200) {
              urlImagem = response.Item.urlPublica;
              nomeImagem = response.Item.fileName;
              tipoImagem = fileTypeArquivo;
            } else {
              throw new Error('Erro ao fazer upload do arquivo.');
            }
          } else {
            throw new Error('Erro ao assinar a URL.');
          }
        }


        const complementosPizza = normalizarComplementosPizzaParaSalvar();

        let obj = {
          nome: nome,
          tamanhos: sizes,
          massas: complementosPizza.massas,
          bordas: complementosPizza.bordas,
          tipo: tipo,
          urlImagem: urlImagem,
          nomeImagem: nomeImagem,
          tipoImagem: tipoImagem,
          cobrarMaiorValor: checkedCobrarPorMaiorValor
        };

        const objectRequest = {
          index: index,
          nome: obj
        }
        console.log("objectRequest", objectRequest);

        let id = loja;

        console.log("id", id);

        await requestService(
          alterarProdutosCategoriaEmpresa.url.replace("{id}", id.replaceAll("#", "%23")).concat("?produtoscategoria=sim"),
          {
            method: alterarProdutosCategoriaEmpresa.method,
            body: JSON.stringify(objectRequest),
            headers: [
              ["token", window.localStorage.getItem("token")]
            ],
            credentials: 'include'
          },
          history,
          (response: any) => {
            console.log(response);
            if (response) {
              setTextToast("Cadastro realizado com sucesso.");
              setShowToast(true);

              const atributosAtualizados = response.message.Attributes;
              const categoriasAtualizadas = atributosAtualizados.categoriaProdutos || [];
              const catalogoAtualizado = atributosAtualizados.catalogoProdutos || dadosEmpresa.catalogoProdutos || [];

              setListaCategoriaProdutos(categoriasAtualizadas);
              setDadosEmpresa({
                ...dadosEmpresa,
                categoriaProdutos: categoriasAtualizadas,
                catalogoProdutos: catalogoAtualizado
              });

              if (embedded && categoriaSelecionada === listaCategoriaProdutos[Number(index)]?.nome && index !== '') {
                onSelecionarCategoria?.(nome);
              }
              setShowDetalhes(false);

            } else if (response.status === 400) {
              console.log(response);
              setTextToast(response.message || "Ocorreu um erro ao efetuar o cadastro.");
              setShowToast(true);

            }
            setShowLoading(false);
          },
          (error: any) => {
            console.log(error);
            setTextToast("Ocorreu um erro ao efetuar o cadastro.");
            setShowToast(true);
            setShowLoading(false);
          })



      } catch (error) {
        console.log("erro", error);
      }
    }

    await atualizar().finally(() => { setShowLoading(false) });
  }

  async function handleReorder(event: CustomEvent<ItemReorderEventDetail>) {
    if (!podeEditar || showLoading || event.detail.from === event.detail.to) {
      event.detail.complete(false);
      return;
    }
    const anteriores = listaCategoriaProdutos;
    const atualizadas = [...anteriores];
    const [movida] = atualizadas.splice(event.detail.from, 1);
    atualizadas.splice(event.detail.to, 0, movida);
    event.detail.complete(false);
    setListaCategoriaProdutos(atualizadas);
    setShowLoading(true);
    try {
      const resp = await fetch(ordernarItemCategoriaProdutosEmpresa.url.replace('{id}', loja.replace(/#/g, '%23')), {
        method: ordernarItemCategoriaProdutosEmpresa.method,
        headers: [['token', localStorage.getItem('token') || '']],
        body: JSON.stringify({ categoriaProdutos: atualizadas }),
        credentials: 'include',
      });
      const retorno = await resp.json();
      if (!resp.ok || !Array.isArray(retorno?.Item?.Attributes?.categoriaProdutos)) throw new Error('Falha ao ordenar');
      const categorias = retorno.Item.Attributes.categoriaProdutos;
      setListaCategoriaProdutos(categorias);
      setDadosEmpresa({ ...dadosEmpresa, categoriaProdutos: categorias });
    } catch {
      setListaCategoriaProdutos(anteriores);
      setTextToast('Não foi possível ordenar as categorias. Tente novamente.');
      setShowToast(true);
    } finally {
      setShowLoading(false);
    }
  }


  const editarCategoriaSelecionada = () => {
    if (!menuCategoria || !podeEditar) return;
    const { categoria: value, indice } = menuCategoria;
    setMenuCategoria(null);
    setEtapa(2);
    setIndex(String(indice));
    setTipo(value.tipo);
    setNome(value.nome);
    setFileArquivos(null);
    setFileDataURL(value.urlImagem || null);
    setSizes(Array.isArray(value.tamanhos) ? value.tamanhos : []);
    setMassas(Array.isArray(value.massas) ? value.massas : []);
    setBordas(Array.isArray(value.bordas) ? value.bordas : []);
    setCheckedCobrarPorMaiorValor(value.cobrarMaiorValor || false);
    setShowDetalhes(true);
  };

  const excluirCategoriaSelecionada = () => {
    if (!menuCategoria || !podeEditar) return;
    const { categoria, indice } = menuCategoria;
    setMenuCategoria(null);
    mostartAlerta({
      backdropDismiss: false,
      header: 'Remover categoria',
      message: `Deseja remover a categoria <strong>${escaparHtml(categoria.nome)}</strong>?`,
      buttons: [
        { text: 'Cancelar', role: 'cancel' },
        { text: 'Confirmar', cssClass: 'primary', handler: () => deletarCategoria(indice) },
      ],
    });
  };

  const loadCategoriaProdutos = () => {


    if (listaCategoriaProdutos == undefined) return;

    if (listaCategoriaProdutos.length === 0) {
      return (

        <IonItem lines="full" key={"semAgenda"}>

          <IonLabel>
            <h2 style={{ "verticalAlign": "middle" }}><strong>Nenhuma categoria cadastrada</strong></h2>
          </IonLabel>

        </IonItem>


      );
    }



    return (
      <>
        <IonReorderGroup disabled={!podeEditar || showLoading} onIonItemReorder={handleReorder}>
          {listaCategoriaProdutos.map((value: any, index: any) => {
            const quantidadeProdutos = (dadosEmpresa.catalogoProdutos || []).filter((produto: any) => produto.categoria === value.nome).length;
            return (
            <IonItem lines={embedded ? 'none' : 'full'} key={value.nome}
              className={embedded ? `catalogo-categoria-item${categoriaSelecionada === value.nome ? ' catalogo-categoria-item--selected' : ''}` : ''}>
              {podeEditar && <IonReorder slot="start" className="list-reorder-handle" aria-label={`Ordenar categoria ${value.nome}`}>
                <IonIcon icon={reorderTwo} aria-hidden="true" />
              </IonReorder>}
              <IonLabel hidden={embedded} style={{ fontSize: "12px", maxWidth: "60px" }}>
                <img alt="" style={{ objectFit: 'cover', width: "50px", height: "50px", borderRadius: '5px' }} src={value.urlImagem || imgDefaultImage}></img>
              </IonLabel>

              {embedded ? (
                <button type="button" className="catalogo-categoria-select"
                  aria-pressed={categoriaSelecionada === value.nome}
                  onClick={() => onSelecionarCategoria?.(value.nome)}>
                  <strong>{value.nome}</strong>
                  <span>{quantidadeProdutos} {quantidadeProdutos === 1 ? 'produto' : 'produtos'}</span>
                </button>
              ) : <>
                <IonLabel style={{ fontSize: '12px' }}>{value.nome}</IonLabel>
                <IonLabel style={{ fontSize: '12px' }}>{value.tipo}</IonLabel>
              </>}
              <IonButtons slot="end" className="catalogo-categoria-actions">
                <IonButton hidden={!podeEditar} color="primary" aria-label={`Ações da categoria ${value.nome}`}
                  onClick={(event) => setMenuCategoria({ categoria: value, indice: index, event: event.nativeEvent })}>
                  <IonIcon slot="icon-only" icon={ellipsisVertical} />
                </IonButton>
              </IonButtons>

            </IonItem>
            );
          })}
        </IonReorderGroup>
      </>
    );
  }


  const validate = (sizes: Array<{ name: string; sabores: number }>) => {
    let isValid = true;
    let errors: Array<{ message: string }> = [];

    if (!nome) {
      isValid = false;
      errors.push({ message: `Nome não pode estar vazio.` });
    }

    sizes?.forEach((size, index) => {
      if (!size.name) {
        isValid = false;
        errors.push({ message: `Nome do tamanho no item ${index + 1} não pode estar vazio.` });
      }

      if (size.sabores <= 0) {
        isValid = false;
        errors.push({ message: `Qtd. de sabores no item ${index + 1} não foi selecionado.` });
      }
    });

    // Validação das massas
    massas?.forEach((massa, index) => {
      if (!massa.name) {
        isValid = false;
        errors.push({ message: `Nome da massa no item ${index + 1} não pode estar vazio.` });
      }

      if (!massa.price) {
        isValid = false;
        errors.push({ message: `Preço da massa no item ${index + 1} não pode estar vazio.` });
      }
    });

    // Validação das bordas
    bordas?.forEach((borda, index) => {
      if (!borda.name) {
        isValid = false;
        errors.push({ message: `Nome da borda no item ${index + 1} não pode estar vazio.` });
      }

      if (!borda.price) {
        isValid = false;
        errors.push({ message: `Preço da borda no item ${index + 1} não pode estar vazio` });
      }
    });


    return { isValid, errors };
  };


  async function salvar() {

    const { isValid, errors } = validate(sizes);

    if (!isValid && errors.length > 0) {
      console.log('Erros de validação:', errors);

      // Mapeia o array de erros e retorna um array de strings para o IonToast
      const errorMessages: any = errors.map((error) => `${error.message}`);
      setTextToast(errorMessages.join('<br>'));
      setShowToast(true);
      return;
    }


    await assinaUploadS3ArquivoESalvar(fileArquivos);


  }


  const addSize = () => {
    setSizes([...sizes, { name: '', sabores: 0 }]);
  };

  const updateSize = (index: number, field: string, value: any) => {
    const newSizes: any = [...sizes];
    newSizes[index][field] = value;
    setSizes(newSizes);
  };

  const removeSize = (index: number) => {
    const newSizes = sizes.filter((_, i) => i !== index);
    setSizes(newSizes);
  };


  const addMassa = () => {
    setMassas([...massas, { name: '', price: 0 }]);
  };

  const updateMassa = (index: number, field: string, value: any) => {
    const newMassas: any = [...massas];
    newMassas[index][field] = value;
    setMassas(newMassas);
  };

  const removeMassa = (index: number) => {
    const newMassas = massas.filter((_, i) => i !== index);
    setMassas(newMassas);
  };



  const addBorda = () => {
    setBordas([...bordas, { name: '', price: 0 }]);
  };

  const updateBorda = (index: number, field: string, value: any) => {
    const newBordas: any = [...bordas];
    newBordas[index][field] = value;
    setBordas(newBordas);
  };

  const removeBorda = (index: number) => {
    const newBordas = bordas.filter((_, i) => i !== index);
    setBordas(newBordas);
  };


  function avancarEtapa2(tipo: any) {

    if (tipo) {
      setEtapa(2);
      if (inputRef.current) {
        inputRef.current.setFocus();
      }


    }
    else {
      setTextToast("Selecione as opções para avançar.");
      setShowToast(true);
    }
  }

  // Função para atualizar o valor do input no índice específico
  const onChangeValorMassaArray = (e: any, index: number) => {
    e.preventDefault();

    let v = e.target.value;

    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");

    const newValues = [...massas];
    newValues[index] = { ...newValues[index], price: v }; // Corrigido para não substituir o objeto
    setMassas(newValues);
  };


  // Função para atualizar o valor do input no índice específico
  const onChangeValorBordaArray = (e: any, index: number) => {
    e.preventDefault();

    let v = e.target.value;

    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");

    const newValues = [...bordas];
    newValues[index] = { ...newValues[index], price: v }; // Corrigido para não substituir o objeto
    setBordas(newValues);
  };

  // Metodo chamado quando é selecionado um arquivo para subida
  async function ChangeHandlerInputFile(e: any) {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.match(imageMimeType)) {
        alert("Tipo da imagem inválido");
        return;
      }


      // if (fileArquivos && fileArquivos.size > 100000) {
      const fotoReduzida = await ReduzirFoto(file);
      console.log("Tamanho comprimido:", fotoReduzida.size);
      setFileArquivos(fotoReduzida);
      // }
      // else {
      //   setFileArquivos(file);
      // }




    }
    else {
      alert("Arquivo não selecionado");
      return;
    }
  }

  async function ReduzirFoto(file: File) {
    const tamanhoMaximoEmBytes = 0.1 * 1024 * 1024;

    // Evita recomprimir imagens que já estão leves, preservando a qualidade original.
    if (file.size <= tamanhoMaximoEmBytes) {
      return file;
    }

    const options = {
      maxSizeMB: 0.1,
      maxWidthOrHeight: 800,
      useWebWorker: true,
      initialQuality: 0.8
    }

    return await imageCompression(file, options);
  }


  const PageContainer = embedded ? 'section' : IonPage;
  const ContentContainer = embedded ? 'div' : IonContent;

  return (
    <PageContainer className={embedded ? 'ProdutosCategoriasNovo catalogo-categorias-panel' : 'ProdutosCategoriasNovo'}>
      {embedded ? (
        <>
          <div className="catalogo-categorias-heading">
            <h2>Categorias <span>{listaCategoriaProdutos.length}</span></h2>
            {podeEditar && <IonButton color="tertiary" size="default" onClick={abrirNovaCategoria}>
              <IonIcon icon={add} slot="start" />Nova categoria
            </IonButton>}
          </div>
          {/* {podeEditar && <p className="catalogo-reorder-hint">Arraste pelos pontos para ordenar.</p>} */}
          <button type="button" className={`catalogo-todas-categorias${categoriaSelecionada === '' ? ' catalogo-todas-categorias--selected' : ''}`}
            aria-pressed={categoriaSelecionada === ''} onClick={() => onSelecionarCategoria?.('')}>
            <span>Todas as categorias</span><span>{(dadosEmpresa.catalogoProdutos || []).length}</span>
          </button>
        </>
      ) : <IonHeader className="ion-no-border">
        <IonToolbar color="primary">
          <IonButtons slot="start"><IonButton onClick={() => history.goBack()}><IonIcon slot="icon-only" icon={arrowBack} /></IonButton></IonButtons>
          <IonTitle>Categorias dos produtos</IonTitle>
        </IonToolbar>
        {isWeb && podeEditar && <IonToolbar>
          <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 8 }}>
            <IonButton color="tertiary" onClick={abrirNovaCategoria}><IonIcon icon={add} slot="start" />Nova categoria</IonButton>
          </div>
        </IonToolbar>}
      </IonHeader>}
      <ContentContainer>
        {!embedded && !isWeb && podeEditar && <IonFab vertical="bottom" horizontal="center" slot="fixed">
          <IonFabButton color="tertiary" class="custom-fab-button" onClick={abrirNovaCategoria}><IonIcon color="light" icon={add} /></IonFabButton>
        </IonFab>}
        <IonList className={embedded ? 'catalogo-categorias-list' : undefined}>{loadCategoriaProdutos()}</IonList>

        <IonPopover isOpen={menuCategoria !== null} event={menuCategoria?.event}
          onDidDismiss={() => setMenuCategoria(null)}>
          <IonList>
            <IonItem lines="none" button onClick={editarCategoriaSelecionada}>
              <IonIcon icon={pencilOutline} slot="start" />
              <IonLabel>Editar</IonLabel>
            </IonItem>
            <IonItem lines="none" button onClick={excluirCategoriaSelecionada}>
              <IonIcon icon={trashOutline} slot="start" />
              <IonLabel>Excluir</IonLabel>
            </IonItem>
            <IonItem lines="none" button onClick={() => setMenuCategoria(null)}>
              <IonIcon icon={closeOutline} slot="start" />
              <IonLabel>Cancelar</IonLabel>
            </IonItem>
          </IonList>
        </IonPopover>

        <IonModal onDidPresent={() => {
          if (inputRef.current) {
            inputRef.current.setFocus();
          }
        }} isOpen={showDetalhes} onDidDismiss={() => {
          setShowDetalhes(false);
          setIndex("");
          setNome("");
          setTipo("");
          setEtapa(1);
          setSizes([]);
          setMassas([]);
          setBordas([]);
        }}>


          <>
            <IonHeader>
              <IonToolbar color="primary">
                <IonButtons slot="start">
                  <IonIcon slot="icon-only" icon={arrowBack} onClick={() => setShowDetalhes(false)} />
                </IonButtons>
                <IonTitle>{index !== "" ? "Editar categoria" : "Nova categoria"}</IonTitle>
              </IonToolbar>
            </IonHeader>
            <IonContent>


              <div className="cat-tipo-state" hidden={etapa != 1}>
                <p className="cat-tipo-title">Selecione o que deseja cadastrar</p>

                <div className="cat-tipo-card">
                  <div className="cat-tipo-card-icon">
                    <IonIcon icon={fastFoodOutline} />
                  </div>
                  <div className="cat-tipo-card-info">
                    <strong>Produtos</strong>
                    <span>Crie os produtos do seu cardápio</span>
                  </div>
                  <IonButton fill="outline" size="small" color="primary" onClick={(e) => { e.stopPropagation(); setTipo('simples'); avancarEtapa2('simples'); }}>Selecionar</IonButton>
                </div>

                <div className="cat-tipo-card">
                  <div className="cat-tipo-card-icon">
                    <IonIcon icon={pizzaOutline} />
                  </div>
                  <div className="cat-tipo-card-info">
                    <strong>Pizzas</strong>
                    <span>Defina tamanhos, número de sabores</span>
                  </div>
                  <IonButton fill="outline" size="small" color="primary" onClick={(e) => { e.stopPropagation(); setTipo('pizzas'); avancarEtapa2('pizzas'); }}>Selecionar</IonButton>
                </div>

                <div className="cat-tipo-card cat-tipo-card--advanced">
                  <div className="cat-advanced-header">
                    <div className="cat-tipo-card-icon cat-tipo-card-icon--advanced">
                      <IonIcon icon={cogOutline} />
                    </div>
                    <div className="cat-tipo-card-info">
                      <div className="cat-advanced-title">
                        <strong>Gestão avançada</strong>
                        <IonBadge color="medium">Opcional</IonBadge>
                      </div>
                      <span>Controle estoque, custo e disponibilidade dos itens usados como complementos.</span>
                    </div>
                    <IonToggle
                      aria-label="Ativar gestão avançada de itens adicionais"
                      checked={tipo === 'complementos'}
                      onIonChange={(e) => setTipo(e.detail.checked ? 'complementos' : '')}
                    />
                  </div>

                  {tipo === 'complementos' && (
                    <div className="cat-advanced-details">
                      <strong>Quando usar esta opção?</strong>
                      <p>
                        Ative quando os itens usados nos complementos precisarem ser cadastrados individualmente no catálogo. Assim você poderá controlar estoque e custo, além de habilitar ou desabilitar cada item.
                      </p>
                      <IonButton
                        fill="outline"
                        size="small"
                        color="primary"
                        onClick={(e) => {
                          e.stopPropagation();
                          avancarEtapa2('complementos');
                        }}
                      >
                        Continuar com gestão avançada
                      </IonButton>
                    </div>
                  )}
                </div>
              </div>








              <div hidden={etapa != 2} style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>

                {/* Card INFORMAÇÕES */}
                <div className="cat-form-card">
                  <div className="cat-section-header">
                    <div className="cat-section-icon" style={{ background: '#FFF3E0' }}>
                      <IonIcon icon={storefrontOutline} style={{ color: 'var(--ion-color-primary)' }} />
                    </div>
                    <div>
                      <div className="cat-section-title">Informações</div>
                      <div className="cat-section-subtitle">Dados básicos da categoria</div>
                    </div>
                  </div>
                  <div className="cat-info-layout">
                    <div className="cat-info-fields">
                      <div className="cat-field">
                        <div className="cat-field-label">Nome *</div>
                        <IonInput className="cat-field-input" placeholder="Digite o nome da categoria" value={nome} ref={(ref) => inputRef.current = ref} autoCorrect='true' autoCapitalize='true' required onIonInput={(e: any) => setNome(e.target.value)} />
                      </div>
                    </div>
                    <div className="cat-info-image">
                      <input ref={inputUploadArquivoRef} onChange={ChangeHandlerInputFile} type="file" accept="image/*" style={{ display: 'none' }} />
                      <div className="cat-image-dropzone cat-image-dropzone--tall" onClick={() => inputUploadArquivoRef.current?.click()}>
                        {fileDataURL ? (
                          <div className="cat-image-preview">
                            <img
                              src={fileDataURL}
                              alt="Imagem da categoria"
                            />
                          </div>

                        ) : (
                          <>
                            <div className="catalogo-image-dropzone-icon">
                              <IonIcon icon={cameraOutline} style={{ fontSize: '32px', color: 'var(--ion-color-primary)' }} />
                            </div>
                            <span style={{ fontWeight: 600, fontSize: '14px', color: '#333' }}>Adicionar imagem</span>
                            <span style={{ fontSize: '12px' }}>Selecione para adicionar uma imagem</span>
                            <span style={{ fontSize: '11px', color: '#bbb' }}>PNG, JPG até 5MB</span>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>



                {/* Card TAMANHOS */}
                {tipo === 'pizzas' && (
                  <div className="cat-form-card">
                    <div className="cat-section-header">
                      <div className="cat-section-icon" style={{ background: '#F3E5F5' }}>
                        <IonIcon icon={pizzaOutline} style={{ color: '#7B1FA2' }} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div className="cat-section-title">Tamanhos</div>
                        <div className="cat-section-subtitle">Defina os tamanhos e sabores</div>
                      </div>
                      <IonButton fill="clear" size="small" color="primary" onClick={addSize}>
                        <IonIcon icon={addOutline} slot="start" />
                        Adicionar
                      </IonButton>
                    </div>
                    {sizes && sizes.length > 0 && (
                      <div style={{ border: '1px solid #e0e0e0', borderRadius: '10px', overflow: 'hidden' }}>
                        {/* Cabeçalho */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', background: '#f9f9f9', borderBottom: '1px solid #e0e0e0' }}>
                          <div style={{ flex: 1, fontSize: '11px' }}>Nome do tamanho*</div>
                          <div style={{ width: '120px', textAlign: 'center', fontSize: '11px' }}>Qtd. sabores*</div>
                          <div style={{ width: '32px' }} />
                        </div>
                        {sizes.map((size, index) => (
                          <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 12px', borderBottom: index < sizes.length - 1 ? '1px solid #f0f0f0' : 'none', background: '#fff' }}>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <IonInput value={size.name} placeholder="Ex: Grande" style={{ '--padding-start': '0', '--padding-top': '0', '--padding-bottom': '0', fontSize: '14px', color: '#333' } as any} onIonInput={(e: any) => updateSize(index, 'name', e.target.value)} />
                            </div>
                            <div style={{ width: '120px', flexShrink: 0, display: 'flex', gap: '4px', justifyContent: 'center' }}>
                              {[1, 2, 3, 4].map((num) => (
                                <IonButton key={num} size="small" color={size.sabores === num ? 'danger' : 'light'} style={{ '--padding-start': '8px', '--padding-end': '8px', minWidth: '26px', height: '26px' } as any} onClick={() => updateSize(index, 'sabores', num)}>{num}</IonButton>
                              ))}
                            </div>
                            <div style={{ width: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                              <IonIcon icon={trashOutline} onClick={() => removeSize(index)} style={{ fontSize: '17px', color: '#ef4444', cursor: 'pointer' }} />
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    {(!sizes || sizes.length === 0) && <div className="cat-empty-hint">Nenhum tamanho adicionado ainda.</div>}
                  </div>
                )}

                {/* Card MASSAS */}
                {tipo === 'pizzas' && (
                  <div className="cat-form-card">
                    <div className="cat-section-header">
                      <div className="cat-section-icon" style={{ background: '#F0FDF4' }}>
                        <IonIcon icon={layersOutline} style={{ color: '#22C55E' }} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div className="cat-section-title">Massas</div>
                        <div className="cat-section-subtitle">Tipos de massa disponíveis</div>
                      </div>
                      <IonButton fill="clear" size="small" color="primary" onClick={addMassa}>
                        <IonIcon icon={addOutline} slot="start" />
                        Adicionar
                      </IonButton>
                    </div>
                    {massas && massas.length > 0 && (
                      <div style={{ border: '1px solid #e0e0e0', borderRadius: '10px', overflow: 'hidden' }}>
                        {/* Cabeçalho */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', background: '#f9f9f9', borderBottom: '1px solid #e0e0e0' }}>
                          <div style={{ flex: 1, fontSize: '11px' }}>Nome da massa*</div>
                          <div style={{ width: '72px', textAlign: 'right', fontSize: '11px' }}>Preço*</div>
                          <div style={{ width: '32px' }} />
                        </div>
                        {massas.map((massa, index) => (
                          <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 12px', borderBottom: index < massas.length - 1 ? '1px solid #f0f0f0' : 'none', background: '#fff' }}>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <IonInput value={massa.name} placeholder="Ex: Massa tradicional" style={{ '--padding-start': '0', '--padding-top': '0', '--padding-bottom': '0', fontSize: '14px', color: '#333' } as any} onIonInput={(e: any) => updateMassa(index, 'name', e.target.value)} />
                            </div>
                            <div style={{ width: '72px', flexShrink: 0 }}>
                              <IonInput type="tel" maxlength={14} placeholder="0,00" value={massa.price || ''} style={{ '--padding-start': '6px', '--padding-end': '6px', '--padding-top': '6px', '--padding-bottom': '6px', fontSize: '13px', textAlign: 'right', border: '1px solid #e0e0e0', borderRadius: '6px', background: '#fff' } as any} onIonChange={(e: any) => onChangeValorMassaArray(e, index)} />
                            </div>
                            <div style={{ width: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                              <IonIcon icon={trashOutline} onClick={() => removeMassa(index)} style={{ fontSize: '17px', color: '#ef4444', cursor: 'pointer' }} />
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    {(!massas || massas.length === 0) && <div className="cat-empty-hint">Nenhuma massa adicionada ainda.</div>}
                  </div>
                )}

                {/* Card BORDAS */}
                {tipo === 'pizzas' && (
                  <div className="cat-form-card">
                    <div className="cat-section-header">
                      <div className="cat-section-icon" style={{ background: '#EFF6FF' }}>
                        <IonIcon icon={ellipseOutline} style={{ color: '#3B82F6' }} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div className="cat-section-title">Bordas</div>
                        <div className="cat-section-subtitle">Tipos de borda disponíveis</div>
                      </div>
                      <IonButton fill="clear" size="small" color="primary" onClick={addBorda}>
                        <IonIcon icon={addOutline} slot="start" />
                        Adicionar
                      </IonButton>
                    </div>
                    {bordas && bordas.length > 0 && (
                      <div style={{ border: '1px solid #e0e0e0', borderRadius: '10px', overflow: 'hidden' }}>
                        {/* Cabeçalho */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', background: '#f9f9f9', borderBottom: '1px solid #e0e0e0' }}>
                          <div style={{ flex: 1, fontSize: '11px' }}>Nome da borda*</div>
                          <div style={{ width: '72px', textAlign: 'right', fontSize: '11px' }}>Preço*</div>
                          <div style={{ width: '32px' }} />
                        </div>
                        {bordas.map((borda, index) => (
                          <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 12px', borderBottom: index < bordas.length - 1 ? '1px solid #f0f0f0' : 'none', background: '#fff' }}>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <IonInput value={borda.name} placeholder="Ex: Borda catupiry" style={{ '--padding-start': '0', '--padding-top': '0', '--padding-bottom': '0', fontSize: '14px', color: '#333' } as any} onIonInput={(e: any) => updateBorda(index, 'name', e.target.value)} />
                            </div>
                            <div style={{ width: '72px', flexShrink: 0 }}>
                              <IonInput type="tel" maxlength={14} placeholder="0,00" value={borda.price || ''} style={{ '--padding-start': '6px', '--padding-end': '6px', '--padding-top': '6px', '--padding-bottom': '6px', fontSize: '13px', textAlign: 'right', border: '1px solid #e0e0e0', borderRadius: '6px', background: '#fff' } as any} onIonChange={(e: any) => onChangeValorBordaArray(e, index)} />
                            </div>
                            <div style={{ width: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                              <IonIcon icon={trashOutline} onClick={() => removeBorda(index)} style={{ fontSize: '17px', color: '#ef4444', cursor: 'pointer' }} />
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    {(!bordas || bordas.length === 0) && <div className="cat-empty-hint">Nenhuma borda adicionada ainda.</div>}
                  </div>
                )}

                {/* Card CONFIGURAÇÕES */}
                {tipo === 'pizzas' && (
                  <div className="cat-form-card">
                    <div className="cat-section-header">
                      <div className="cat-section-icon" style={{ background: '#F3F4F6' }}>
                        <IonIcon icon={cogOutline} style={{ color: '#6B7280' }} />
                      </div>
                      <div>
                        <div className="cat-section-title">Configurações</div>
                        <div className="cat-section-subtitle">Regras de cobrança da pizza</div>
                      </div>
                    </div>
                    <div className="cat-toggle-row">
                      <div style={{ flex: 1 }}>
                        <div className="cat-toggle-label">Cobrar pelo maior valor</div>
                        <div className="cat-toggle-desc">O valor cobrado será o do maior tamanho</div>
                      </div>
                      <IonToggle checked={checkedCobrarPorMaiorValor} onIonChange={e => setCheckedCobrarPorMaiorValor(e.detail.checked)} />
                    </div>
                  </div>
                )}

              </div>
            </IonContent>
            {/* <IonFooter hidden={etapa != 1} className="ion-no-border">

              <IonToolbar>
                <IonButton hidden={etapa != 1}
                  onClick={async () => {
                    avancarEtapa2();
                  }}
                  expand="block"
                  type="submit"
                  style={{ margin: "0px", textAlign: "right" }}
                >
                  Avançar
                </IonButton>
              </IonToolbar>
            </IonFooter> */}

            <IonFooter hidden={etapa != 2} className="ion-no-border">
              <IonToolbar>
                <IonButton onClick={() => salvar()} expand="block" type="submit">Salvar</IonButton>
              </IonToolbar>
            </IonFooter>
          </>

        </IonModal>

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

      </ContentContainer>

    </PageContainer>
  );


};

export default ProdutosCategoriasNovo;
